import { render, staticRenderFns } from "./LanguageFlagPicker.vue?vue&type=template&id=1731959c&"
import script from "./LanguageFlagPicker.vue?vue&type=script&lang=ts&"
export * from "./LanguageFlagPicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports